{
  "v7.gouvernance.annuler": "Cancel",
  "v7.gouvernance.capacite.aucune_donnee": "No non-zero data this month.",
  "v7.gouvernance.capacite.choisir": "Choose a row to see its detail.",
  "v7.gouvernance.capacite.consommation_ia": "AI compute consumption (GPU minutes), never human capacity.",
  "v7.gouvernance.capacite.consommees": "GPU minutes consumed this month",
  "v7.gouvernance.capacite.detail": "{{missions}} active mission(s) · {{restantes}} estimated min remaining · {{consommees}} min consumed.",
  "v7.gouvernance.capacite.fermer": "Close the detail",
  "v7.gouvernance.capacite.liste": "Cost and capacity per project",
  "v7.gouvernance.capacite.missions": "Active missions",
  "v7.gouvernance.capacite.mois": "Month",
  "v7.gouvernance.capacite.mois_choisi": "Chosen month (UTC).",
  "v7.gouvernance.capacite.mois_courant": "Current month (UTC).",
  "v7.gouvernance.capacite.non_ouverts": "{{n}} project(s) not open (unnamed)",
  "v7.gouvernance.capacite.projet": "Project",
  "v7.gouvernance.capacite.restantes": "Estimated remaining GPU minutes",
  "v7.gouvernance.capacite.totaux": "Totals: {{projets}} project(s), {{missions}} active mission(s), {{restantes}} estimated min remaining, {{consommees}} min consumed.",
  "v7.gouvernance.capacite.totaux_attente": "Totals being read.",
  "v7.gouvernance.capacite.vide": "No consumption this month.",
  "v7.gouvernance.code.ACCESS_DENIED": "Access denied: you are not a member of this programme.",
  "v7.gouvernance.code.CONTEXTE_INCOMPLET": "Incomplete context: the target programme could not be established.",
  "v7.gouvernance.code.DROIT_NON_TENU": "Your profile does not hold the right required for this action.",
  "v7.gouvernance.code.GARDE_DROIT_ABSENTE": "Operation closed: no right guard declared.",
  "v7.gouvernance.code.NOT_FOUND": "Not found.",
  "v7.gouvernance.code.PROGRAMME_CONFIRMATION_PROJETS_TOUCHES": "The inheriting projects changed since you read them: reread the list and confirm again.",
  "v7.gouvernance.code.PROGRAMME_REGLE_HERITEE": "Rule inherited from the organisation: protected, it cannot be removed at programme level.",
  "v7.gouvernance.code.REQUIREMENT_CODE_EXISTS": "This rule code is already taken in this programme.",
  "v7.gouvernance.code.REQUIREMENT_HAS_WAIVER_HISTORY": "The rule or one of its inherited lines has waiver history: it cannot be removed.",
  "v7.gouvernance.code.RESOURCE_UNAVAILABLE": "Not found in this programme (or outside your organisation).",
  "v7.gouvernance.code.SANS_SESSION": "No session or session expired: sign in again.",
  "v7.gouvernance.code.VALIDATION_ERROR": "A field is missing or out of range: correct the input.",
  "v7.gouvernance.etat.chargement": "Loading {{quoi}}…",
  "v7.gouvernance.etat.erreur": "{{quoi}}: cannot be read at the moment.",
  "v7.gouvernance.etat.reessayer": "Retry",
  "v7.gouvernance.etat.refus": "{{quoi}}: reading refused for this profile.",
  "v7.gouvernance.evenement.acteur": "Actor",
  "v7.gouvernance.evenement.action": "Action",
  "v7.gouvernance.evenement.attente": "Separation of duties read with the event.",
  "v7.gouvernance.evenement.cible": "Target",
  "v7.gouvernance.evenement.correlation": "Correlation",
  "v7.gouvernance.evenement.correles": "Correlated events",
  "v7.gouvernance.evenement.horodatage": "Timestamp",
  "v7.gouvernance.evenement.immuable": "Immutable event: no change possible.",
  "v7.gouvernance.evenement.integrite": "Integrity not attested by a fingerprint: sensitive content redacted by the gateway.",
  "v7.gouvernance.evenement.membres": "Members and current permissions",
  "v7.gouvernance.evenement.preuve_absente": "No correlated evidence within the programme scope.",
  "v7.gouvernance.evenement.preuves": "Evidence",
  "v7.gouvernance.evenement.projet": "Project",
  "v7.gouvernance.evenement.resultat": "Outcome",
  "v7.gouvernance.evenement.retour_defaut": "Direct access: going back opens the log without filters.",
  "v7.gouvernance.evenement.retour_filtres": "Back to the log with your filters and position.",
  "v7.gouvernance.evenement.sans_correlation": "Correlated events: no correlation for this event.",
  "v7.gouvernance.evenement.separation": "Separation of duties",
  "v7.gouvernance.evenement.sod_aucune_decision": "No decision is taken here.",
  "v7.gouvernance.evenement.sod_identiques": "Same person for request and decision: flagged.",
  "v7.gouvernance.evenement.sod_insuffisante": "Insufficient history to identify requester and decider.",
  "v7.gouvernance.evenement.sod_non_applicable": "Not applicable to this event.",
  "v7.gouvernance.evenement.sod_personnes": "Requester: {{demandeur}} · decider: {{decideur}}.",
  "v7.gouvernance.evenement.sod_respectee": "Distinct people: separation respected.",
  "v7.gouvernance.evenement.titre_section": "Event",
  "v7.gouvernance.geste.erreur": "The action did not complete. Try again in a moment.",
  "v7.gouvernance.instance.actions": "Actions",
  "v7.gouvernance.instance.aucune_seance": "No meeting held.",
  "v7.gouvernance.instance.conclusions": "Conclusions",
  "v7.gouvernance.instance.du_modele": "{{libelle}} — model {{modele}}, version {{version}}.",
  "v7.gouvernance.instance.indicateurs": "Indicators",
  "v7.gouvernance.instance.ordre_du_jour": "Agenda",
  "v7.gouvernance.instance.participants": "Participants",
  "v7.gouvernance.instance.rien": "None.",
  "v7.gouvernance.instance.seance_du": "Meeting of {{le}}",
  "v7.gouvernance.instance.seances": "Meeting history",
  "v7.gouvernance.instance.titre_section": "Governance body",
  "v7.gouvernance.instance.vide": "No information for this body.",
  "v7.gouvernance.journal.acteur": "Actor",
  "v7.gouvernance.journal.action": "Action",
  "v7.gouvernance.journal.appliquer": "Apply filters",
  "v7.gouvernance.journal.aucun_resultat": "No event matches the filters.",
  "v7.gouvernance.journal.correlation": "Correlation",
  "v7.gouvernance.journal.dates_inversees": "The period end precedes its start: correct the dates.",
  "v7.gouvernance.journal.debut": "Period start",
  "v7.gouvernance.journal.evenements": "Programme events",
  "v7.gouvernance.journal.filtres": "Filters (optional)",
  "v7.gouvernance.journal.fin": "Period end",
  "v7.gouvernance.journal.fin_de_liste": "End of the list.",
  "v7.gouvernance.journal.fuseau": "Time in UTC (explicit time zone).",
  "v7.gouvernance.journal.ligne": "by {{acteur}} on {{objet}}",
  "v7.gouvernance.journal.ordre": "{{total}} event(s), newest first; projects taken at the time of the action.",
  "v7.gouvernance.journal.ouvrir": "Open the event",
  "v7.gouvernance.journal.page_suivante": "Next page",
  "v7.gouvernance.journal.perimetre": "Scope: programme {{programme}} only, model {{modele}} version {{version}}.",
  "v7.gouvernance.journal.perimetre_attente": "Programme scope being read.",
  "v7.gouvernance.journal.portee_imposee": "The programme scope is enforced by the gateway: no organisation entry outside the programme.",
  "v7.gouvernance.journal.projet_rattache": "project {{projet}} (attached at the time of the action)",
  "v7.gouvernance.journal.resultat": "Outcome",
  "v7.gouvernance.journal.resultat_echec": "Failure",
  "v7.gouvernance.journal.resultat_refus": "Denied",
  "v7.gouvernance.journal.resultat_succes": "Success",
  "v7.gouvernance.journal.resultat_tous": "All",
  "v7.gouvernance.journal.vide": "No event for this programme.",
  "v7.gouvernance.modele_fige": "Programme frozen model: {{libelle}} (version {{version}}).",
  "v7.gouvernance.non_ouverts": "{{n}} programme project(s) not open to you, counted without detail.",
  "v7.gouvernance.onglet.portes": "Gates and committee",
  "v7.gouvernance.onglet.referentiel": "Programme standards",
  "v7.gouvernance.onglets": "Programme governance",
  "v7.gouvernance.ouvrir_projet": "Open the project",
  "v7.gouvernance.portes.choisir": "Choose a gate to see its criteria and decision.",
  "v7.gouvernance.portes.decision.ajournee": "postponed by the committee",
  "v7.gouvernance.portes.decision.franchie": "passed by the committee",
  "v7.gouvernance.portes.decision.refusee": "refused by the committee",
  "v7.gouvernance.portes.decision_detail": "Decision: {{decision}} ({{instance}}, meeting of {{le}}).",
  "v7.gouvernance.portes.etat.a_venir": "upcoming",
  "v7.gouvernance.portes.etat.franchie": "passed",
  "v7.gouvernance.portes.instances": "Model bodies",
  "v7.gouvernance.portes.instances_titre": "Governance bodies",
  "v7.gouvernance.portes.ouvrir_instance": "Open the record: {{libelle}}",
  "v7.gouvernance.portes.revue_mensuelle": "Monthly review, with its service report.",
  "v7.gouvernance.portes.sans_decision": "No committee decision for this gate.",
  "v7.gouvernance.portes.seances_dans_la_fiche": "Next meeting and members: in the body record.",
  "v7.gouvernance.portes.titre": "Programme gates",
  "v7.gouvernance.portes.vide": "The programme frozen model defines no gate.",
  "v7.gouvernance.regles.ajoutee": "Rule {{code}} added to the programme; addition written to the log.",
  "v7.gouvernance.regles.ajouter": "Add to the programme",
  "v7.gouvernance.regles.ajouter_titre": "Add a rule to the programme",
  "v7.gouvernance.regles.artefact": "Programme standards: {{libelle}} (model artefact).",
  "v7.gouvernance.regles.aucun_projet_touche": "No project currently inherits {{code}}.",
  "v7.gouvernance.regles.categorie": "Category",
  "v7.gouvernance.regles.choisir": "Choose a rule to see its detail.",
  "v7.gouvernance.regles.code": "Rule code",
  "v7.gouvernance.regles.comptes": "{{total}} rule(s): {{organisation}} from the organisation, {{propres}} specific to the programme, inherited by its projects.",
  "v7.gouvernance.regles.confirmation": "Removal confirmation",
  "v7.gouvernance.regles.confirmer_retrait": "Confirm removal",
  "v7.gouvernance.regles.controle": "Control",
  "v7.gouvernance.regles.detail": "Category {{categorie}} · control {{controle}} · threshold {{seuil}}",
  "v7.gouvernance.regles.dod": "Definition of done",
  "v7.gouvernance.regles.enonce": "Statement",
  "v7.gouvernance.regles.etat.a_verifier": "to check",
  "v7.gouvernance.regles.etat.conforme": "compliant",
  "v7.gouvernance.regles.etat.en_derogation": "under waiver",
  "v7.gouvernance.regles.etat.non_conforme": "non-compliant",
  "v7.gouvernance.regles.etat.perimee": "expired",
  "v7.gouvernance.regles.heritee": "inherited from the organisation",
  "v7.gouvernance.regles.incomplet": "Code, statement and control are required.",
  "v7.gouvernance.regles.jamais_plus_faible": "A programme rule strengthens the organisation one, never weaker: the gateway checks it.",
  "v7.gouvernance.regles.nature": "Kind",
  "v7.gouvernance.regles.nfr": "Non-functional requirement",
  "v7.gouvernance.regles.projets_touches": "Removing {{code}} also removes the rule from these {{n}} inheriting project(s):",
  "v7.gouvernance.regles.propre": "programme-specific",
  "v7.gouvernance.regles.protegee": "Rule inherited from the organisation: protected, it is removed at organisation level, never at programme level.",
  "v7.gouvernance.regles.retiree": "Rule {{code}} removed from the programme and {{n}} project(s); removal written to the log.",
  "v7.gouvernance.regles.retirer": "Remove the rule from the programme",
  "v7.gouvernance.regles.seuil": "Threshold (optional)",
  "v7.gouvernance.regles.titre": "Programme rules",
  "v7.gouvernance.regles.vide": "No rule: projects follow the organisation standards.",
  "v7.gouvernance.retour_journal": "Back to the log",
  "v7.gouvernance.retour_portes": "Back to gates and committee",
  "v7.gouvernance.retour_programme": "Back to the programme",
  "v7.gouvernance.roadmap.choisir": "Choose a milestone to see its projects and versions.",
  "v7.gouvernance.roadmap.etat_jalon.en_retard": "late",
  "v7.gouvernance.roadmap.etat_jalon.livre": "delivered",
  "v7.gouvernance.roadmap.etat_jalon.non_date": "undated",
  "v7.gouvernance.roadmap.etat_jalon.prevu": "planned",
  "v7.gouvernance.roadmap.fiche_repere": "Milestone record",
  "v7.gouvernance.roadmap.jalon": "Milestone {{version}}",
  "v7.gouvernance.roadmap.jalons": "Milestones and versions",
  "v7.gouvernance.roadmap.points": "{{fait}} / {{engage}} points",
  "v7.gouvernance.roadmap.produit": "Product roadmap",
  "v7.gouvernance.roadmap.produit_vide": "No product roadmap for this programme.",
  "v7.gouvernance.roadmap.projet_resume": "{{epics}} epic(s), {{retard}} late, {{versions}} version(s)",
  "v7.gouvernance.roadmap.retard_signale": "delay flagged",
  "v7.gouvernance.roadmap.sprints": "Programme projects roadmap",
  "v7.gouvernance.roadmap.statut.active": "active",
  "v7.gouvernance.roadmap.statut.closed": "closed",
  "v7.gouvernance.roadmap.statut.planned": "planned",
  "v7.gouvernance.roadmap.vide": "No sprint planned in the programme projects.",
  "v7.gouvernance.sans_programme": "No programme selected: choose a programme in the context selector.",
  "v7.gouvernance.suivi.artefact": "{{libelle}}: produced by the programme.",
  "v7.gouvernance.suivi.artefacts": "Artefacts produced by the programme",
  "v7.gouvernance.suivi.aucun_rapport": "No report read.",
  "v7.gouvernance.suivi.contribution": "Contribution of the chosen project",
  "v7.gouvernance.suivi.csv": "Export as CSV",
  "v7.gouvernance.suivi.csv_ok": "File {{nom}} produced.",
  "v7.gouvernance.suivi.epics": "Epics done / total",
  "v7.gouvernance.suivi.etat.aucun_projet": "no project",
  "v7.gouvernance.suivi.etat.dans_les_temps": "on time",
  "v7.gouvernance.suivi.etat.donnees_insuffisantes": "insufficient data",
  "v7.gouvernance.suivi.etat.en_retard": "late",
  "v7.gouvernance.suivi.etat.sans_cible": "no target",
  "v7.gouvernance.suivi.etat.termine": "completed",
  "v7.gouvernance.suivi.impact.high": "high impact",
  "v7.gouvernance.suivi.impact.low": "low impact",
  "v7.gouvernance.suivi.impact.medium": "medium impact",
  "v7.gouvernance.suivi.imprimer": "Print or save as PDF",
  "v7.gouvernance.suivi.par_projet": "Progress per project and milestone",
  "v7.gouvernance.suivi.projet": "Project",
  "v7.gouvernance.suivi.rapport": "Progress report",
  "v7.gouvernance.suivi.rapport_du": "Report of {{le}}",
  "v7.gouvernance.suivi.rapports": "Reports by period",
  "v7.gouvernance.suivi.risques": "{{n}} open risk(s), {{hauts}} high",
  "v7.gouvernance.suivi.sprint": "Active sprint (done / committed)",
  "v7.gouvernance.suivi.synthese": "Summary: {{etat}} · likely date {{date}} · target milestone {{cible}}.",
  "v7.gouvernance.suivi.version": "Version (in preparation or delivered)",
  "v7.gouvernance.suivi.vide": "No project in the programme: nothing to track.",
  "v7.gouvernance.titre.capacite": "Programme cost and capacity",
  "v7.gouvernance.titre.evenement": "Programme event detail",
  "v7.gouvernance.titre.gouvernance": "Governance and standards — programme standards",
  "v7.gouvernance.titre.instance": "Programme governance step",
  "v7.gouvernance.titre.journal": "Programme audit log",
  "v7.gouvernance.titre.portes": "Governance and standards — gates and committee",
  "v7.gouvernance.titre.roadmap": "Programme roadmap",
  "v7.gouvernance.titre.suivi": "Programme progress tracking"
}
